import React from 'react';
import { IStateAwareArea } from 'types/map';
import { getIconStyle } from 'components/Map/AreaMarker/styles';

export interface Props {
  area: IStateAwareArea,
  selected?: boolean,
}

export default function LockIcon({ selected = false }: Props) {
  return (
    <img
      alt=""
      src={'/img/lock-icon.png'}
      style={getIconStyle(selected)}
    />
  );
}
